import React, { useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import UnderDevelopmentPage from '../../UnderDevelopmentPage'
import { AppBar, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Toolbar } from '@mui/material'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialButton from '../../../components/MaterialButton'
import ActivePlans from './components/ActivePlans'
import ClosedPlans from './components/ClosedPlans'
import AddTestPlan from './components/AddTestPlan'



const TestPlans = () => {

  const [activeTab, setActiveTab] = useState("active");
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleTestPlanOpen = () => {
    setOpen(true);
  };



  return (
    <DashboardLayout>

      {/* <Box sx={{ flexGrow: 1 }}>
        <AppBar position="sticky"
          sx={{
            backgroundColor: "#D7DEED",
            borderRadius: '8px'
          }}>
          <Toolbar>
            <MaterialTypography
              variant="h5"
              noWrap
              fontWeight="bold"
              color='dark'
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
              Test Plans
            </MaterialTypography>
            <MaterialButton variant="contained" color='dark' size="small" onClick={handleTestPlanOpen}>Create Test Plan</MaterialButton>
          </Toolbar>
          <Box>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "30px",
                  padding: "1px 20px",
                }}
              >
                <div
                  onClick={() => setActiveTab("active")}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: activeTab === "active" ? "#1a73e8" : "#666",
                    fontWeight: activeTab === "active" ? "600" : "normal",
                    paddingBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Active Plans
                  {activeTab === "active" && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        height: "2px",
                        width: "100%",
                        backgroundColor: "#1a73e8",
                      }}
                    ></div>
                  )}
                </div>

                <div
                  onClick={() => setActiveTab("closed")}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: activeTab === "closed" ? "#1a73e8" : "#666",
                    fontWeight: activeTab === "closed" ? "600" : "normal",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    paddingBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Completed Plans
                  {activeTab === "closed" && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        height: "2px",
                        width: "100%",
                        backgroundColor: "#1a73e8",
                      }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </Box>
        </AppBar>
      </Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <div>
            {activeTab === "active" ? <ActivePlans search={search} filter={filter} /> : <ClosedPlans />}
          </div>
        </Grid>
      </Grid>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontSize: '14px', fontWeight: 'bold', padding: 1 }}>Create Test Plan</DialogTitle>
        <DialogContent dividers sx={{
          overflow: 'hidden',
          '&::-webkit-scrollbar': { display: 'none' }, 
        }}>
          <AddTestPlan />
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleClose} color="secondary" variant="outlined" size="small">
            Cancel
          </MaterialButton>
          <MaterialButton onClick={handleClose} color="dark" variant="contained" size="small">
            Submit
          </MaterialButton>
        </DialogActions>
      </Dialog> */}


      <UnderDevelopmentPage />
    </DashboardLayout>
  )
}

export default TestPlans
